<script>
import BaseView from '../base/base-view'
import getViewConfig from './outdoor-view-config'

export default {
    name: 'OutdoorView',
    extends: BaseView,

    // -------------------------------- Props ---------------------------------------
    props:{
        covers:{type: Boolean, default: false },
        transparentLevels:{type: Array, default: ()=>[] },
    },

    // -------------------------------- Computed ------------------------------------
    computed:{
        outdoorViewConfig() {
            return getViewConfig(this.covers, this.transparentLevels)
        }
    },

    // -------------------------------- Hooks ---------------------------------------
    created(){
        //Each child view should call this method to include their view config prop name to inheritance collection
        this.addInheritedView('outdoorViewConfig')
    },

/*    ViewApi.register_event("mouse_over_building", (data)=> {
        console.log("MOUSE OVER Building: ", data);
        let id = data !== undefined? data.building_id : "";
        ViewApi.set_building_focus_color(id);
    });*/
}
</script>
